(()=>{'use strict';function init(){const root=document.getElementById('cm014');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const technical=new Set(['view','preview_theme_id','pb','cmh','section_id','sections','_fd','_sc','preview_key']);
 const inbound=new URLSearchParams(location.search);
 const requested=inbound.get('cmh')||'A';const variants=JSON.parse(root.querySelector('[data-title-variants]').textContent);const choice=/^[ABC]$/.test(requested)&&typeof variants[requested]==='string'&&variants[requested].trim()?requested:'A';const heading=root.querySelector('h1');heading.innerHTML=variants[choice]||variants.A;const title=heading.textContent.trim();document.title=title;root.dataset.titleChoice=choice;
 const meta=(selector,attributes,value)=>{let el=document.head.querySelector(selector);if(!el){el=document.createElement('meta');Object.entries(attributes).forEach(([k,v])=>el.setAttribute(k,v));document.head.append(el)}el.content=value};
 meta('meta[property="og:title"]',{property:'og:title'},title);
 meta('meta[name="description"]',{name:'description'},root.dataset.seoDescription);
 meta('meta[property="og:description"]',{property:'og:description'},root.dataset.seoDescription);
 meta('meta[name="robots"]',{name:'robots'},'noindex, nofollow');
 const offerFor=()=>root.querySelector('#cm014-offer-mid').getBoundingClientRect().bottom>0?'#cm014-offer-mid':'#cm014-offer';
 root.querySelectorAll('[data-offer-link]').forEach(a=>a.addEventListener('click',event=>{event.preventDefault();const href=a.dataset.ctaPosition==='sticky'?offerFor():a.getAttribute('href');const target=root.querySelector(href);if(!target)return;window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'chinology_lp_cta',lp:root.dataset.version,position:a.dataset.ctaPosition,label:a.textContent.trim(),destination:href});target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}));
 const bar=root.querySelector('.cm-progress div');let scheduled=false;
 const sticky=root.querySelector('.cm-topbar'),heroCTA=root.querySelector('[data-cta-position="hero"]');
 const competing=[...root.querySelectorAll('.cm-cta,.cm-offer-card,.cm-offer-compact')];
 function progress(){scheduled=false;const r=root.getBoundingClientRect();const length=root.scrollHeight-innerHeight;bar.style.width=Math.max(0,Math.min(100,(-r.top/Math.max(1,length))*100))+'%';
  const visible=el=>{const b=el.getBoundingClientRect();return b.height>0&&b.bottom>0&&b.top<innerHeight};
  sticky.hidden=heroCTA.getBoundingClientRect().bottom>=0||competing.some(visible)||document.body.classList.contains('js-drawer-open')||!!document.querySelector('#mc-sidecart [data-ajax-cart-section].translate-x-0');
 }
 function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(progress)}}addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);progress();
 document.addEventListener('sidecart:open',()=>{sticky.hidden=true;setTimeout(schedule,200)});document.addEventListener('sidecart:close',schedule);document.addEventListener('click',schedule);
 new ResizeObserver(schedule).observe(root);
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 root.querySelectorAll('[data-comparison-tabs]').forEach(group=>{
  const tabs=[...group.querySelectorAll('[role="tab"]')],panels=[...group.querySelectorAll('[role="tabpanel"]')];
  const select=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});if(focus)tabs[index].focus()};
  tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(index));tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(next,true)})});
 });
 root.querySelectorAll('[data-session-clock]').forEach(clock=>{
  const configured=Number(clock.dataset.duration),duration=Number.isFinite(configured)&&configured>0?Math.floor(configured):983;
  const started=Date.now();let handle;
  const update=()=>{
   if(!clock.isConnected){clearInterval(handle);return}
   const remaining=Math.max(0,duration-Math.floor((Date.now()-started)/1000));
   const parts={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
   Object.entries(parts).forEach(([unit,value])=>{const el=clock.querySelector('[data-clock-unit="'+unit+'"]');if(el)el.textContent=String(value).padStart(2,'0')});
   clock.dataset.remaining=String(remaining);if(remaining===0)clearInterval(handle);
  };
  handle=setInterval(update,250);clock.cmCleanup=()=>clearInterval(handle);update();
 });
 root.querySelectorAll('[data-video-frame]').forEach(frame=>{
  const video=frame.querySelector('[data-cm-video]');if(!video)return;
  let inView=false,manualPause=false,loaded=false;
  const allowed=()=>!reduced.matches&&!navigator.connection?.saveData&&!document.hidden;
  const load=()=>{if(!loaded){video.src=video.dataset.src;video.load();loaded=true}};
  const play=()=>{load();video.play().catch(()=>{})};
  video.controls=false;video.muted=true;video.tabIndex=0;video.setAttribute('role','button');
  const label=video.getAttribute('aria-label');
  const reflect=()=>video.setAttribute('aria-label',(video.paused?'Play: ':'Pause: ')+label);
  video.addEventListener('playing',()=>{frame.classList.add('is-playing');reflect()});video.addEventListener('pause',reflect);reflect();
  const activate=()=>{if(video.paused){manualPause=false;play()}else{manualPause=true;video.pause()}};
  video.addEventListener('click',activate);video.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();activate()}});
  const warm=new IntersectionObserver(entries=>{if(entries[0].isIntersecting&&allowed()){load();warm.disconnect()}},{rootMargin:'350px'});
  const observe=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;if(!inView)video.pause();else if(allowed()&&!manualPause)play()},{threshold:.25});
  const begin=()=>{warm.observe(video);observe.observe(video)};
  if(frame.hasAttribute('data-hero-video')){if(document.readyState==='complete')begin();else window.addEventListener('load',begin,{once:true})}else begin();
  reduced.addEventListener('change',()=>{if(!allowed())video.pause();else if(inView&&!manualPause)play()});
  document.addEventListener('visibilitychange',()=>{if(!allowed())video.pause();else if(inView&&!manualPause)play()});
 });
 root.querySelectorAll('[data-carousel]').forEach(carousel=>{
  const track=carousel.querySelector('[data-carousel-track]'),slides=[...track.children],dots=[...carousel.querySelectorAll('[data-carousel-dot]')];
  if(!slides.length)return;let current=0,raf=false;
  const update=()=>{raf=false;current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));carousel.querySelector('[data-carousel-count]').textContent=(current+1)+' / '+slides.length;dots.forEach((d,i)=>{if(i===current)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')});if(carousel.hasAttribute('data-adaptive-height')){track.style.height=slides[current].getBoundingClientRect().height+'px';slides.forEach((s,i)=>s.querySelectorAll('button').forEach(b=>b.tabIndex=i===current?0:-1))}};
  const go=i=>track.scrollTo({left:((i+slides.length)%slides.length)*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});
  carousel.querySelector('[data-carousel-prev]').addEventListener('click',()=>go(current-1));
  carousel.querySelector('[data-carousel-next]').addEventListener('click',()=>go(current+1));
  dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));
  track.addEventListener('scroll',()=>{if(!raf){raf=true;requestAnimationFrame(update)}},{passive:true});
  track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1))}});
  let previousWidth=track.clientWidth;
  new ResizeObserver(()=>{const width=track.clientWidth;if(!carousel.hasAttribute('data-adaptive-height')||width!==previousWidth){track.scrollTo({left:current*width,behavior:'instant'});previousWidth=width}update()}).observe(track);
  if(carousel.hasAttribute('data-adaptive-height')){const resize=new ResizeObserver(update);slides.forEach(slide=>resize.observe(slide));}
  update();
 });
 }if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('[data-session-clock]').forEach(clock=>clock.cmCleanup?.())})})();

/* cm109-meta-events-v1: page-local events for the existing Meta pixel. */
(() => {
  'use strict';
  const root = document.getElementById('cm014');
  if (!root || window.CM014MetaEventsV1 || window.Shopify?.designMode) return;
  window.CM014MetaEventsV1 = true;
  const pixel = '1924362164566100';
  const queue = [{name: 'ViewContent'}];
  const bound = new WeakSet();
  let initialized = false;

  function flush() {
    try { sendPending(); } catch (_) { /* Analytics must never interrupt an add. */ }
  }

  function sendPending() {
    if (window.Shopify?.customerPrivacy?.marketingAllowed?.() === false) return;
    let fbq = window.fbq;
    if (typeof fbq !== 'function') {
      fbq = window.fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    if (!initialized) {
      let exists = (fbq.queue || []).some(args => args[0] === 'init' && String(args[1]) === pixel);
      if (typeof fbq.getState === 'function') {
        exists = exists || (fbq.getState().pixels || []).some(item => String(item.id) === pixel);
      }
      if (!exists) fbq('init', pixel);
      initialized = true;
    }
    while (queue.length) {
      const event = queue[0];
      if (event.data) fbq('trackSingle', pixel, event.name, event.data);
      else fbq('trackSingle', pixel, event.name);
      queue.shift();
    }
  }

  function bind() {
    const api = window.liquidAjaxCart;
    if (!api || typeof api.subscribeToCartAjaxRequests !== 'function' || bound.has(api)) return;
    bound.add(api);
    api.subscribeToCartAjaxRequests((request, subscribe) => {
      const form = request.info?.initiator;
      if (request.requestType !== 'add' || !(form instanceof Element) ||
          !form.matches('[data-cm014-form]') || !root.contains(form)) return;
      let tracked = false;
      subscribe(result => {
        if (tracked || !result.responseData?.ok || result.info?.cancel) return;
        tracked = true;
        queue.push({name: 'AddToCart', data: {currency: 'USD'}});
        flush();
      });
    });
  }

  document.addEventListener('liquidAjaxCartInit', bind, true);
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('visitorConsentCollected', flush);
  bind();
  flush();
})();
